export const VEHICLE_TYPES = [

  {
    value: "sedan",
    label: "Sedán"
  },

  {
    value: "suv",
    label: "SUV"
  },

  {
    value: "van",
    label: "Van"
  },

  {
    value: "minibus",
    label: "Minibús"
  },

  {
    value: "bus",
    label: "Bus"
  },

  {
    value: "pickup",
    label: "Pickup"
  },

  {
    value: "other",
    label: "Otro"
  }

];